// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Uqog","resendInfoText":"OnGoingPaymentBox_resendInfoText__3Sh7p"};